import { useResidentContext } from "../../../features/residents/provider/ResidentProvider";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";
import { FormEnums } from "../../../services/api/types/forms/enums/FormEnums";
import { useFormHistoryWithOffline } from "app/features/offline/hooks/useFormHistoryWithOffline";

export function AddAdmissionChecklist() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/admission`
    : undefined;

  const { data: entries, isLoading } = useFormHistoryWithOffline({
    tag: FormEnums.ADMISSION_CHECKLIST,
    residentId: resident?.id,
  });

  const entry = entries?.[0];

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.ADMISSION_CHECKLIST}
      backPath={backPath}
      entry={entry}
      isLoading={isLoading}
    />
  );
}
